<template lang="pug">
  div.vein-tips(:style="pos",  v-drag="info")
    div.head
      div.time {{time}}
      i.fa.fa-close(@click.prevent="closeTips(item)")
    div.introduce
      ul
        li(v-for="event in item.list")
          a(:href="event.url", target="_blank") {{event.title}}
</template>

<script>
import moment from 'moment'
export default {
  name: 'VeinTips',
  props: {
    item: {
      type: Object,
      required: true
    },
    closeTips: {
      type: Function,
      required: true
    }
  },
  directives: {
    drag: {
    // 指令的定义
      bind: (el, binding) => {
        let oDiv = el // 当前元素
        let info = binding.value
        console.log(el, binding)
        oDiv.onmousedown = function (e) {
          let disX = e.clientX - oDiv.offsetLeft
          let disY = e.clientY - oDiv.offsetTop

          document.onmousemove = function (e) {
            // 通过事件委托，计算移动的距离
            let l = e.clientX - disX
            let t = e.clientY - disY
            if (l + 230 > info.width) {
              l = info.width - 230
            } else if (l < 0) {
              l = 0
            }

            let renderHeight = info.lines * 16 + 37
            if (t + renderHeight > info.height) {
              t = info.height - renderHeight
            } else if (t < 0) {
              t = 0
            }
            // 移动当前元素
            oDiv.style.left = l + 'px'
            oDiv.style.top = t + 'px'
          }
          document.onmouseup = function (e) {
            document.onmousemove = null
            document.onmouseup = null
          }
        }
      }
    }
  },
  data () {
    return {
      pos: ''
    }
  },
  created () {
    this.pos = {
      left: this.item.pos[0] + 'px',
      top: this.item.pos[1] + 'px'
    }
    this.info = {
      width: this.item.width,
      height: this.item.height,
      lines: this.item.list.length
    }
    this.time = moment(this.item.publishTime).format('YYYY-MM-DD')
  },
  mounted () {

  }
}
</script>
<style lang="scss" scoped>
.vein-tips {
  position: absolute;
  left:100px;
  top: 100px;
  background: rgba(0,0,0,0.5);
  color:#fff;
  width: 230px;
  .head {
    display: flex;
    flex-flow: row nowrap;
    padding: 5px;
    align-items: center;
    justify-content: space-between;
    border-bottom:1px solid #fff;
  }
  .introduce {
    padding: 5px;
  }
  li {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:hover{
      cursor: crosshair;
    }
  }
  li a {
    color:#fff;
    &:hover{
      color:#488dc6;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventTendency/VeinTips.vue